export function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function idToColor(id: number): string {
  const baseColors: string[] = [
    "#000000",
    "#FFFFFF",
    "#FF0000",
    "#00FF00",
    "#0000FF",
    "#FFFF00",
    "#00FFFF",
    "#FF00FF",
    "#C0C0C0",
    "#808080",
    "#800000",
    "#808000",
    "#008000",
    "#800080",
    "#008080",
    "#000080",
    "#FFA07A",
    "#006400",
    "#ADFF2F",
    "#87CEEB",
    "#00BFFF",
    "#7FFFD4",
    "#66CDAA",
    "#FFD700",
    "#FFA500",
    "#556B2F",
    "#6A5ACD",
    "#483D8B",
    "#2F4F4F",
    "#000000",
    "#8B4513",
    "#A0522D",
    "#FFE4B5",
    "#FFDAB9",
    "#FF7F50",
    "#FF6347",
    "#8FBC8F",
    "#3CB371",
    "#191970",
    "#7B68EE",
    "#BA55D3",
    "#9370DB",
    "#FF1493",
    "#DB7093",
    "#696969",
    "#778899",
    "#A52A2A",
    "#800000",
    "#4682B4",
    "#4169E1",
    "#F0E68C",
    "#BDB76B",
    "#DC143C",
    "#B22222",
    "#9ACD32",
    "#00FF7F",
    "#5F9EA0",
    "#008B8B",
    "#1E90FF",
    "#6495ED",
    "#DA70D6",
    "#FF00FF",
    "#9932CC",
    "#8B008B",
    "#708090",
    "#DEB887",
    "#D2B48C",
    "#FF69B4",
    "#C71585",
    "#00008B",
    "#CD853F",
    "#D2691E",
    "#008080",
    "#6B8E23",
    "#FF8C00",
    "#8B0000",
    "#20B2AA",
    "#87CEFA",
    "#DDA0DD",
  ];

  // Calculate which set of 25 the ID belongs to and the index within that set
  const setId = Math.floor((id - 1) / 25);
  const colorIndex = (id - 1) % 25;

  // Apply variation based on setId
  // Variation involves modifying the brightness of the color
  const variationFactor = setId % 10; // Limit the variation factor to cycle every 10 to avoid too much repetition

  // Convert base color from hex to RGB
  const baseColor = baseColors[colorIndex];
  let { r, g, b } = hexToRgb(baseColor);

  // Apply a slight variation based on the set ID
  r = (r + variationFactor * 15) % 256;
  g = (g + variationFactor * 15) % 256;
  b = (b + variationFactor * 15) % 256;

  // Convert back to hex
  return rgbToHex(r, g, b);

  // Convert a hex color to RGB
  function hexToRgb(hex: string): { r: number; g: number; b: number } {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { r, g, b };
  }

  // Convert an RGB color to hex
  function rgbToHex(r: number, g: number, b: number): string {
    return (
      "#" +
      [r, g, b]
        .map((x) => {
          const hex = x.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("")
    );
  }
}
